module.exports = __webpack_public_path__ + "img/d55ef45cd6cfe9cbc2077386dbda4578.png";